<template>
  <div>
    <uhero
      :image="heroData.image"
      :title="heroData.title"
      :body="heroData.body"
      :mobile="heroData.mobile"
      color="black"
    >
      <div class="container">
        <div class="course-hero-mobile">
          <div class="workshop_hero_content_mobile">
            <h3 class="workshop__text_mobile" style="color: black">
              {{ heroData.title }}
            </h3>
            <p class="workshop_desc_mobile" style="color: black">
              {{ heroData.body }}
            </p>
          </div>
        </div>
      </div>
    </uhero>
    <u-nav-wrap>
      <unav :items="navItems" v-model="navItem" @input="filter"></unav>
      <usearch
        v-model="search"
        @search="searchCourse"
        placeholder="Search by Name or Category"
      ></usearch>
    </u-nav-wrap>
    <u-card-list>
      <u-course-card
        :image="c.image"
        :title="c.name"
        :lessons="`${c.videos.length} Lessons`"
        duration="Unkownn"
        v-for="c in showCourses"
        :key="c.id"
        @click="GotoBlogByID(c.id)"
      ></u-course-card>
    </u-card-list>
    <section class="section certificate_thumb_wrapper">
      <div class="container">
        <div class="certificate_bg">
          <p class="certificate_content_item">
            Share to get free
            <span>certificate</span>
          </p>
          <img
            style="border: 1px solid grey;"
            src="../assets/images/online_certificate.png"
            alt=""
            class="certificate_thumb img-fluid"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      heroData: {
        mobile: "course-hero-mobile",
        image: require("../assets/images/online_course_hero.png"),
        title: "Learn from our online courses",
        body:
          "Upskill offers you free video lessons to improve your skills and after completing your course you can download the certificate for free, if you share it on social media."
      },
      navItem: "",
      navItems: [],
      courses: [],
      showCourses: [],
      searched: "" //unnecessary
    };
  },
  methods: {
    searchCourse(value) {
      this.searched = value;
    },
    filter(category) {
      if (category === "All") {
        this.showCourses = this.courses;
      } else {
        let result = [];
        this.courses.forEach(course => {
          let categories = course.categories.split(",");
          if (categories.includes(category)) {
            result.push(course);
          }
        });
        this.showCourses = result;
      }
    }
  },
  created() {
    // this.courses = this.$courses.getAllCourses();
    // this.navItems = this.$courses.getCategories();
    this.$mix.getCourses().then(res => {
      this.courses = res.courses;
      this.showCourses = [...this.courses];
      this.navItems = res.categories;
      this.Loaded();
    });
  }
};
</script>
